import { ReactNode, useCallback, KeyboardEvent } from 'react';

import { twMerge } from 'tailwind-merge';

import { Popover } from '../../../Popover';

interface PresetItemProps {
  readonly children: ReactNode;
  readonly onClick?: () => void;
  readonly className?: string;
}

function PresetItem({ children, onClick, className }: PresetItemProps) {
  const classes = twMerge(
    'h-9 rounded-md border-2 border-blue-500 px-4 py-3',
    'flex cursor-pointer items-center justify-center',
    'hover:bg-blue-500 hover:text-white',
    'transition-all',
    'text-sm leading-[14px] tracking-[0.015em] text-blue-500',
    className,
  );

  const onKeyUpHandler = useCallback(
    (e: KeyboardEvent<HTMLDivElement>) => {
      if (e.key === 'Enter') {
        onClick?.();
      }
    },
    [onClick],
  );

  return (
    <Popover.Close asChild>
      <div role="button" tabIndex={0} onClick={onClick} onKeyUp={onKeyUpHandler} className={classes}>
        {children}
      </div>
    </Popover.Close>
  );
}

export { PresetItem };
